import {Pipe, PipeTransform} from "@angular/core";
import {Service} from "../models/service";

@Pipe({ name: 'filter' })
export class FilterPipe implements PipeTransform {

  transform(services: Service[], searchText: string): Service[] {
    if(!services) return [];
    if(!searchText) return services;

    let searchTextSplit = searchText.split(" ").filter(n => n);
    let regexp = '';
    searchTextSplit.forEach((element,key,arr) => {
      regexp = regexp.concat('(?=.*',element,')');
      if(key == (arr.length - 1) ) {
        regexp = regexp.concat('.*');
      }
    });
    //regular expression ignore case. All words must be found from service name or service info (descriprion)
    //eg. (?=.*test)(?=.*service).* -> 'test' and 'service' must be found from name or info order does not matter
    let regularexp = new RegExp(regexp,'i');

    return services.filter( service => {
      return regularexp.test(service.name) || regularexp.test(service.info);
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/pipes/filter-pipe.ts